import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/dashboard/service/service-img.png'
import _imports_1 from '@/assets/img/dashboard/service/background-service.png'
import _imports_2 from '@/assets/img/dashboard/our-policy/img-left.png'
import _imports_3 from '@/assets/img/dashboard/our-policy/img-right.png'
import _imports_4 from '@/assets/img/dashboard/our-policy/img-bottom.png'
import _imports_5 from '@/assets/img/dashboard/our-policy/img-bottom-left.png'
import _imports_6 from '@/assets/img/dashboard/our-policy/img-bottom-right.png'
import _imports_7 from '@/assets/img/dashboard/company/company.png'
import _imports_8 from '@/assets/svg/arrow-right.svg'
import _imports_9 from '@/assets/svg/vector.svg'


const _withScopeId = n => (_pushScopeId("data-v-013b183d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dash-board" }
const _hoisted_2 = { class: "service-wrapper" }
const _hoisted_3 = { class: "service-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title common-title" }, "Service"),
  /*#__PURE__*/_createElementVNode("div", { class: "description common-description" }, "サービス内容")
], -1))
const _hoisted_5 = { class: "service-items" }
const _hoisted_6 = { class: "service-right" }
const _hoisted_7 = {
  key: 0,
  class: "image",
  alt: "img",
  src: _imports_0
}
const _hoisted_8 = {
  key: 1,
  class: "image",
  ref: "refServiceImgRight",
  src: _imports_1,
  alt: "img"
}
const _hoisted_9 = {
  class: "our-policy-wrapper",
  ref: "refOurPolicy"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"title common-title\" data-v-013b183d>Our Policy</div><div class=\"content-left\" data-v-013b183d><img src=\"" + _imports_2 + "\" alt=\"img\" data-v-013b183d></div><div class=\"content-right\" data-v-013b183d><img src=\"" + _imports_3 + "\" alt=\"img\" data-v-013b183d></div><div class=\"content-center\" data-v-013b183d><div class=\"logo\" data-v-013b183d></div><div class=\"text\" data-v-013b183d><div data-v-013b183d>このまちの親しまれる不動産屋さん。</div><div data-v-013b183d>この街の期待に応えられる不動産屋さん。</div></div><div class=\"text\" data-v-013b183d><div data-v-013b183d>私たちは、この街で住まいをささえ、</div><div data-v-013b183d>街のにぎわいとともに成長する不動産屋です。</div></div><div class=\"text\" data-v-013b183d><div data-v-013b183d>これまでも、これからも。</div><div data-v-013b183d>マツザキは、この街の！</div><div data-v-013b183d>いちばん頼れるパートナーであり続けます。</div></div><div class=\"bottom\" data-v-013b183d><img src=\"" + _imports_4 + "\" alt=\"img\" data-v-013b183d></div></div><div class=\"content-bottom-left\" data-v-013b183d><img src=\"" + _imports_5 + "\" alt=\"img\" data-v-013b183d></div><div class=\"content-bottom-right\" data-v-013b183d><img src=\"" + _imports_6 + "\" alt=\"img\" data-v-013b183d></div>", 6)
const _hoisted_16 = [
  _hoisted_10
]
const _hoisted_17 = { class: "company-wrapper" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title common-title" }, "Company", -1))
const _hoisted_19 = { class: "company-content" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: "image"
  })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description common-description" }, "会社情報", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" マツザキハウジングは中野区エリア（西武線～中央線沿線）を中心に不動産をご紹介しています。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("私たちの強みは「この街の不動産屋」であることです。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("この街に根ざし、地域の不動産オーナーさまを元気にしたいと思っています。この街で物件探しをするお客さまに心から喜んでもらいたいと思っています。だからこそ地域に密着し、人と人との心のつながりを大切にしているのです。 ")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "詳しく見る", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "image"
}, null, -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "shop-list" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shop-list__header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title common-title" }, "Shop list"),
  /*#__PURE__*/_createElementVNode("div", { class: "description common-description" }, "店舗一覧")
], -1))
const _hoisted_28 = { class: "shop-list__shop-content" }
const _hoisted_29 = { class: "news" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "news__header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title common-title" }, "News"),
  /*#__PURE__*/_createElementVNode("div", { class: "description common-description" }, "ニュース")
], -1))
const _hoisted_31 = { class: "news__content" }
const _hoisted_32 = { class: "new-list" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "left" }
const _hoisted_35 = { class: "description" }
const _hoisted_36 = { class: "description-right" }
const _hoisted_37 = { class: "date" }
const _hoisted_38 = { class: "date-time" }
const _hoisted_39 = { class: "category" }
const _hoisted_40 = { class: "title" }
const _hoisted_41 = { class: "infor" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "icon",
  src: _imports_9
}, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "一覧を見る", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "image"
}, null, -1))
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_ServiceListItem = _resolveComponent("ServiceListItem")!
  const _component_ShopImage = _resolveComponent("ShopImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _createVNode(_component_Carousel, {
        carouselImages: _ctx.carouselImages,
        onClickImg: _ctx.onClickCarouselImg
      }, null, 8, ["carouselImages", "onClickImg"])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceListItem, (item, index) => {
              return (_openBlock(), _createBlock(_component_ServiceListItem, _mergeProps({
                class: "service-item",
                key: index
              }, { ...item }, {
                onClick: ($event: any) => (_ctx.navigate(item.url)),
                onMouseover: ($event: any) => (_ctx.onHoverService(item)),
                onMouseleave: _ctx.onLeaveService
              }), null, 16, ["onClick", "onMouseover", "onMouseleave"]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
            : (_openBlock(), _createElementBlock("img", _hoisted_8, null, 512))
        ])
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_9, _hoisted_16, 512)
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _hoisted_21,
          _hoisted_22,
          _createElementVNode("div", {
            class: "company-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('/corporate')))
          }, _hoisted_25)
        ])
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfStores, (item, index) => {
            return (_openBlock(), _createBlock(_component_ShopImage, {
              class: "shop-item",
              key: index,
              itemImg: item
            }, null, 8, ["itemImg"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: index,
                onClick: ($event: any) => (_ctx.getDetailNew(item.id))
              }, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, _toDisplayString(item.postDate), 1),
                        _createElementVNode("div", _hoisted_39, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.category, (categoryType, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "item-category",
                              key: index
                            }, _toDisplayString(categoryType?.name), 1))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_41, _toDisplayString(item.summary), 1)
                    ])
                  ])
                ]),
                _hoisted_42
              ], 8, _hoisted_33))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: "news-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigate('/news')))
          }, _hoisted_45)
        ])
      ])
    ])
  ]))
}